import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_LIST_ERROR':
      return action.error;

    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_LIST_LOADING':
      return action.loading;

    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_LIST_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_LIST_SUCCESS':
      return action.retrieved;

    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function filtersData(state = null, action) {
  switch (action.type) {
    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_LIST_FILTER':
      return action.filtersData;

    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function sortData(state = null, action) {
  switch (action.type) {
    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_LIST_SORT':
      return action.sortData;

    case 'LIVE_INTERVIEW_CANDIDATE_INVITATION_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved, filtersData, sortData });
